
import { getUrlParamsString } from '@/lib/utils'

export default {
  props: {
    submenu: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    /**
     * possible values: horizontal, vertical
     */
    variant: {
      type: String,
      default: 'vertical',
    },
    link: String,
    filterKey: String,
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    submenuId() {
      if (this.submenu.title) {
        return `nav-submenu-options-${this.submenu.title.split(' ').join('-')}`
      }
      return `nav-submenu-options-${this.submenu.text.split(' ').join('-')}`
    },
  },
  mounted() {
    const title = this.submenuId
    document.addEventListener('click', (event) => {
      if (event.target.closest(`#${title}`)) this.handleClose()
    })
  },
  methods: {
    handleToggle(event) {
      event.stopPropagation()
      this.open = !this.open
    },
    handleOpen(event) {
      event.stopPropagation()
      if (this.options.length === 0) {
        window.location.href = this.link
      } else {
        this.open = true
      }
    },
    handleClose(event) {
      this.open = false
    },
    getUrlParamsString,
  },
}
